import React from 'react';
import { MainContent, HeroAndPricing, HeroContent, PricingSection } from '../App';
import HeroSection from '../components/HeroSection';
import PricingCard from '../components/PricingCard';
import styled from 'styled-components';


const BackgroundLayer3 = styled.div.attrs({
  className: 'background-layer-3'
})`
  aspect-ratio: 16 / 9;
  bottom: 0;
  left: 0;
  width: 110vw;
  height: 90vh;
  background: url('/backgrounds/jugadores-desktop.png') bottom right/contain no-repeat;
  z-index: 3;
  position: relative;
  left: 10%;

  @media (max-width: 1024px) {
    position:absolute;
    background: url('/backgrounds/jugadores-front.png') top center/cover no-repeat;
    width: 70%;
    height: 100%;
    left: -10%;
    top: 30%;
  }
  
  @media (max-width: 900px) {
    left: -20%; 
  }  

  @media (max-width: 768px) {
    position:absolute;
    background: url('/backgrounds/jugadores-sm.png') top center/cover no-repeat;
    width: 100%;
    left: 0;
    top: 30%;
  }  
  
  @media (max-width: 468px) {
    position:absolute;
    background: url('/backgrounds/jugadores-xs.png') top center/cover no-repeat;
    width: 100%;
    left: 0;
    top: 27%;
  }    
`;

const HomePage: React.FC = () => {
  return (
    <MainContent>
      <HeroContent>
        <HeroSection />
      </HeroContent>
      <HeroAndPricing>
        <BackgroundLayer3 />
        <PricingSection>
          <PricingCard />
        </PricingSection>
      </HeroAndPricing>
    </MainContent>
  );
};

export default HomePage;